import { useState } from "react";
import * as yup from 'yup';

const useHandleForm = (data, modifyCallback, invalidDataCallback) => {

  const isCreate = !Boolean(data);

  const createInitialData = () => {

    const getInitialFieldData = (fieldName) => {
      return isCreate ? [{ key: "", value: "" }] : data[fieldName];
    }

    const fieldNames = [
      "optionList"
    ];

    return fieldNames.reduce((initialData, fieldName) => {
      return ({
        ...initialData,
        [fieldName]: getInitialFieldData(fieldName)
      })
    }, {});
  }

  const [formData, setFormData] = useState(createInitialData());

  const cleanOptionList = (formData) =>
    formData.optionList.filter(
      o => o.key?.trim() !== "" || o.value?.trim() !== ""
    );

  const dataIsValid = async () => {
    const cleanedData = {
      ...formData,
      optionList: cleanOptionList(formData),
    };


    const optionSchema = yup.object().shape({
      "key": yup
        .string()
        .trim()
        .required(),
      "value": yup
        .string()
        .trim()
        .required(),
    });

    const schema = yup.object().shape({
      "optionList": yup
        .array()
        .of(optionSchema)
        .notRequired()
        .default([])
    });

    return await schema.validate(cleanedData, { abortEarly: false })
      .then((castData) => castData)
      .catch(err => {
        if (err instanceof yup.ValidationError) {
          err.inner.forEach(error => {
            console.log(error.message);
          });
          return false;
        }
      });
  }

  const submit = async () => {
    if (await dataIsValid()) {
      let dataToSend = {
        ...formData,
      };

      modifyCallback(dataToSend);

      return true;
    } else {
      invalidDataCallback();
      return false;
    }
  }

  const setFormValue = (index, fieldName, value) => {
    // Copiar el array no alcanza: optionList[index] sigue siendo el mismo objeto
    // que vino por prop, y mutarlo en el lugar cambia la prop y el state
    // anterior sin que nadie lo haya pedido. Se copia tambien la fila.
    const optionList = [...formData.optionList];
    optionList[index] = { ...optionList[index], [fieldName]: value };

    setFormData({
      ...formData,
      "optionList": optionList,
    });
  }

  const handleAddOption = () => {
    setFormData({
      ...formData,
      "optionList": [...formData.optionList, { key: "", value: "" }],
    });
  };

  const handleDeleteOption = (index) => {
    setFormData({
      ...formData,
      "optionList": formData.optionList.filter((_, i) => i !== index),
    });
  };

  return { formData, setFormValue, submit, handleAddOption, handleDeleteOption };
}

export default useHandleForm;
